import React from 'react';

export type BadLocation = { name: string; problem: string };

/**
 * Toast body naming each selected project that cannot be routed to (SW2-2468), so the
 * user knows which project to fix instead of seeing a generic routing error.
 */
const BadLocationsToast = ({ projects }: { projects: BadLocation[] }) => (
  <>
    Can&apos;t get directions. Update the location in these projects&apos; settings, or
    unselect them, then try again:
    <ul style={{ margin: '4px 0 0', paddingLeft: 18 }}>
      {projects.map(({ name, problem }, index) => (
        <li key={index}>
          <strong>{name}</strong> {problem}
        </li>
      ))}
    </ul>
  </>
);

export default BadLocationsToast;
